module.exports = __webpack_public_path__ + "img/top-bar.6d3132df.png";